module.exports = __webpack_public_path__ + "img/italic.503818e3.svg";